window.addEventListener('DOMContentLoaded', () => {
    const thankYou = document.getElementById('thank-you');
    if (thankYou) {
      thankYou.focus();
    }
  });
  